import { Card, Loader, PageHeader } from '@ksyos/design-system';
import { useParams } from '@ksyos/router';
import { PageTemplate } from '@frontend/components/templates/PageTemplate';
import { getSelectedLanguage } from '@frontend/translate';
import { assertHasAccountRequestAuthorization } from '@frontend/utils';
import { AccountRequestProvider } from '../AccountRequestContextProvider';
import { AccountRequestCardHeaderAction } from './AccountRequestCardHeaderAction';
import { AccountRequestForm } from './AccountRequestForm';
import { getAccountRequestPageNavigation } from './AccountRequestPageNavigation';

export function AccountRequestReviewByKsyosPage() {
    const language = getSelectedLanguage();
    assertHasAccountRequestAuthorization('read', true);

    const { accountRequestId } = useParams<'accountRequestId'>();

    return (
        <AccountRequestProvider accountRequestId={accountRequestId ?? ''}>
            {({ isLoading, isEditing }) => (
                <>
                    {isLoading && <Loader />}

                    {!isLoading && (
                        <PageTemplate
                            {...getAccountRequestPageNavigation()}
                            width="small"
                        >
                            <PageHeader title={language.accountRequest.accountRequest} />
                            <Card>
                                <Card.Transition type={isEditing ? 'edit' : 'read'} />
                                <Card.Header
                                    action={<AccountRequestCardHeaderAction />}
                                    title={language.accountRequest.details}
                                />
                                <Card.Body>
                                    <AccountRequestForm />
                                </Card.Body>
                            </Card>
                        </PageTemplate>
                    )}
                </>
            )}
        </AccountRequestProvider>
    );
}
